import React from "react";
import WarrantyComponent from "./warranty.component";
import { useSelector } from "react-redux";

export default function WarrantyContainer({ id, currentLanguage, isTemplateEditor, getTranslation }) {
  const { isVisible } = useSelector(state => isTemplateEditor
    ? state.products.template.workspaceSetting.setting.components[id]
    : state.productPage.components[id]);

  return (
    isVisible && <WarrantyComponent currentLanguage={currentLanguage} getTranslation={getTranslation} />
  );
}
